<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['question']}">
            <label for="question" class="col-sm-2 control-label">Pregunta *</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="question" v-model="data.question">
                <div class="help-block" v-for="e in errors['question']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['answer']}">
            <label for="answer" class="col-sm-2 control-label">Respuesta *</label>
            <div class="col-sm-10">
                <editor id="answer" v-model="data.answer"></editor>

                <div class="help-block" v-for="e in errors['answer']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{ 'has-error': errors['linkedPage'] }">
            <label for="linkedPage" class="col-sm-2 control-label">Ficha Asociada</label>
            <div class="col-sm-10">
                <pages-select id="linkedPage" :multipleLimit="10" v-model="data.linked_page"></pages-select>
                <div class="help-block" v-for="e in errors['linkedPage']">{{ e }}</div>
            </div>
        </div>
        
        
        <div class="form-group" :class="{'has-error': errors['active']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.active" on-text="SI" off-text="NO"></el-switch>
                <div class="help-block" v-for="e in errors['active']">{{e}}</div>
            </div>
        </div>
        <div v-if="data.active" class="form-group" :class="{'has-error': errors['order']}">
            <label for="order" class="col-sm-2 control-label">Posición *</label>
            <div class="col-sm-10">
                <el-select filterable :loading="loading" v-model="data.order">
                    <el-option v-for="c in positions" :label="c.label + '°'" :value="c.value" :key="c.value"></el-option>
                </el-select>
                <!--<input type="number" step="1" class="form-control" id="order" v-model.number="data.order">-->
                <div class="help-block" v-for="e in errors['order']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10">
                <div id="accordionpage" class="accordion accordion-page">
                    <div class="card stage-block"><!-- Acordeon 1er nivel -->
                        <a href="javascript:void(0);" data-level="1" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1" class="btn-link collapsed">
                            <div id="headingtwo" class="card-header">
                                <h2 class="beneficiaries">{{data.question}}   </h2><span class="know-more hidden">Conocer m&aacute;s</span>
                            </div>
                        </a>
                        <div id="collapse1" data-level="1" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapse" aria-expanded="false" style="height: 0px;">
                            <div class="card-body" v-html="data.answer">
                                
                            </div>
                        </div>
                        <div class="line-left"></div>
                    </div>
                </div>
            </div>

        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/faqs/'+this.faq.id+'/topics/'+this.topic.id">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    
    .el-date-picker{
        display: block;
    }
    .el-select{
        display: block;
    }

    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .accordion-page .card a.btn-link {
        display: block;
        color: #000;
        text-decoration: none;
    }
    .life-stages .accordion-page .card.stage-block a.btn-link .card-header h2 {
        color: #000000;
        font-size: 28px;
        margin: 0;
        font-family: Roboto Slab,sans-serif;
    }
    .card.stage-block a, .card.stage-block a:hover, .card.stage-block a h2, .card.stage-block a:hover h2 {
        text-decoration: underline!important;
        color: #240003!important;
    }
    
    .life-stages.container .beneficiaries {
        border-bottom: none;
        width: 85%;
    }
    .faq-alert.life-stages .line-left {
        background: #0080ec;
    }
    .line-left {
        height: 100%;
        position: absolute;
        top: 0;
        width: 12px;
        background: #0080ec;
        left: 0;
    }
    
    .card.stage-block .know-more {
        position: absolute;
        display: block;
        right: 20px;
        top: calc(50% - 10px);
        color: #337ab7;
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .card-body {
        margin-left: 13px;
        padding-top: 18px;
        padding-bottom: 13px;
    }
    .card.stage-block p {
        font-size: 16px;
    }
</style>
<script>
    import Vue from 'vue';
    import Editor from "./Editor.vue"; 
    import { Message } from "element-ui";
    import { Loading } from 'element-ui';
    import PagesSelect from './PagesSelect.vue';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                question: '',
                answer: '',
                linked_page: null,
                active: false,
                order: null,
                created_at: null,
                updated_at: null,
            };
            if (this.linked_page_a){
                let obj = this.linked_page_a;
                let array = Object.keys(obj)
                    .map(function(key) {
                        return obj[key];
                    })
                let array_ids = array.map(function(x) {
                    return x.id
                });
                //console.log('el array',array_ids);
                data.linked_page = array_ids;
            }
            
            return{
                data: _.assign(data, this.question),
                disabled: false,
                must_delete: false,
                errors: {},
                positions: [],
                loading: false
            }
        },
        props: ['faq','topic','question','total_questions','edit', 'linked_page_a'],
        methods:{ 
            submit: function(){
                var self = this;


                var errores = {};

                if (!self.data.question || self.data.question.length == 0) {
                    errores["question"] = ["Debe ingresar una pregunta."];
                }else{
                    axios({
                        url: 'backend/faqs/validate_question',
                        method: 'POST',
                        data: self.data,
                    }).then(function(response){
                        if(response.data.resp_code == 'NOK'){
                            errores["url"] = [response.data.resp_msg];
                        }
                    }).catch(function(error){
                        errores["url"] = ["No fue posible validar url ingresada. Intente nuevamente."];
                    });
                }

                if (!self.data.answer || self.data.answer.length == 0) {
                    errores["answer"] = ["Debe ingresar una respuesta."];
                }

                if (!self.data.order && self.data.active) {
                    errores["order"] = ["Debe seleccionar una posición."];
                }

                if (_.size(errores) > 0) {

                    self.errors = errores;
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }

                axios({
                    url: self.edit ? 'backend/faqs/'+self.faq.id+'/topics/'+self.topic.id+'/questions/'+self.data.id : 'backend/faqs/'+self.faq.id+'/topics/'+self.topic.id+'/questions/',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){

                    self.errors = error.response.data.errors;
                });
            },
        },
        components:{
            Editor,
            PagesSelect
        },
        mounted() {
            var self = this;
            var positions = [];

            var i = 1;
            var len = self.total_questions;
            for (; i <= len+1; ) {
                var position = {value:i, label: i.toString()};
                positions.push(position);
                i++;
            }

            this.positions = positions;
        }
    }
</script>